import { jsx as o, jsxs as p } from "react/jsx-runtime";
import { Box as t, Checkbox as d } from "@mui/material";
import { FileItem as m } from "../list/components/file.js";
import { FileLocationEnum as x } from "../../helpers/daymaptypes.js";
const l = ({
  data: e,
  onOpenFeedbackClick: c,
  isEditMode: r = !1,
  selectedItems: s = [],
  onToggleSelect: i
}) => /* @__PURE__ */ o(t, { sx: { display: "flex", flexFlow: "column", gap: 1 }, children: e == null ? void 0 : e.map((n) => /* @__PURE__ */ p(t, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
  r && i && /* @__PURE__ */ o(
    d,
    {
      checked: s.includes(n.ID),
      onChange: () => i(n.ID)
    }
  ),
  /* @__PURE__ */ o(t, { sx: { flex: 1 }, children: /* @__PURE__ */ o(
    m,
    {
      name: n.LocationType == x.URL ? n.Name : n.Name + "." + n.Extension,
      description: "",
      extension: n.Extension,
      modified: new Date(n.Modified),
      download: !0,
      contentType: 0,
      fileId: n.ID,
      pdf: n.Extension.toLowerCase() == "pdf",
      location: n.LocationType,
      selected: r && s.includes(n.ID),
      onAnnotationsClicked: n.AnnotationsPublished ? c : void 0,
      path: n.Path
    }
  ) })
] }, n.ID)) });
export {
  l as StudentWork
};
//# sourceMappingURL=StudentWork.js.map
